module.exports = __webpack_public_path__ + "img/20210906-1630911082276874.fd8f38a3.jpg";